import { useContext } from 'react';
import { ReturnPortalContext } from '../contexts/ReturnPortalContext';

function useReturnPortalHash(): string {
  const { hash } = useContext(ReturnPortalContext);
  return hash as string;
}

export default useReturnPortalHash;
